import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import queryString from 'query-string'
import moment from 'moment'

import { Button, InputWithButtons } from '@components'
import { FooterSection, LeadingTitle, LinkDocument } from '@components'
import { ReportAPINew, ShortDescriptionAPI } from '@api'
import { Search } from '@icons'
import './RUPS.scss'
import { useTranslation } from 'react-i18next'
import { Pagination } from 'react-bootstrap'

const InvestorContainer = styled.div`
  background-color: #f9f9f9;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const RUPS = function () {
  const { t } = useTranslation()
  const [search, setSearch] = useState('')
  const [yearCollection, setYearCollection] = useState()
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear())
  const [financialReport, setFinancialReport] = useState([])
  const [shortDesc, setShortDesc] = useState(null)

  const getFinancialReport = async () => {
    const filter = {
      cat: 'rups',
      from: `${selectedYear}-01-01`,
      to: `${selectedYear}-12-31`,
      limit: '0',
      page: 1,
      search: search,
      perPage: 100,
    }
    const { data } = await ReportAPINew(queryString.stringify(filter))

    setFinancialReport(data.data != null ? data.data.result : [])
  }

  const generateYear = () => {
    const currentYear = new Date().getFullYear()
    let collection = []

    for (let x = currentYear - 5; x < currentYear; x++) {
      collection.push({
        year: x,
        selected: false,
      })
    }

    collection.push({
      year: currentYear,
      selected: true,
    })

    setYearCollection(collection)
  }

  useEffect(() => {
    generateYear()
    const loadData = async () => {
      const { data } = await ShortDescriptionAPI({ loc: 'rups' })
      setShortDesc(data.data)
    }
    if (!shortDesc) {
      loadData()
    }
  }, [shortDesc])

  useEffect(() => {
    getFinancialReport()
  }, [selectedYear])

  const doSearch = () => {
    getFinancialReport()
  }

  return (
    <InvestorContainer>
      <LeadingTitle
        title={t('RUPS')}
        subtitle={shortDesc !== null ? shortDesc[0].description : ''}
      />

      <div className="rups-page">
        <InputWithButtons
          icon={Search}
          placeholder={`${t('contoh')} : ${t('ringkasan_risalah')}`}
          buttonLabel={t('search')}
          value={search}
          setValue={setSearch}
          doFunction={doSearch}
        />

        <div className="filter-box">
          <div className="title">{t('pilih_tahun')}</div>
          <div className="filter-list">
            {!!yearCollection
              ? yearCollection.map((value, i) => {
                  return (
                    <Button
                      label={value.year}
                      selected={value.year === selectedYear}
                      key={i}
                      onClick={() => setSelectedYear(value.year)}
                    />
                  )
                })
              : ''}
          </div>
        </div>

        <div className="card-box">
          {financialReport.map((data, i) => {
            return (
              <div className="card-item-list" key={i}>
                <LinkDocument
                  label={moment(
                    data.created_date,
                    'DD-MM-YYYY hh:mm:ss'
                  ).format('DD MMMM YYYY')}
                  title={data.title}
                  linkRedirect={data.file}
                  rowLine="1"
                />
              </div>
            )
          })}
        </div>
      </div>

      <FooterSection currentPage={t('RUPS')} />
    </InvestorContainer>
  )
}

export default RUPS
